import { create } from 'zustand';

const initialState = {
  isOpen: false,
  type: '', // 'warning' | 'failed'
  title: '',
  description: '',
  confirmText: '',
  cancelText: '',
  onConfirm: null,
  onCancel: null,
  confirmStyle: 'solid', // 'solid' | 'outline' | 'link'
  cancelStyle: 'outline', // 'solid' | 'outline' | 'link'
  switchOrder: false, // true = cancel first, false = confirm first
};

export const useConfirmDrawer = create((set) => ({
  ...initialState,
  onOpenConfirmDrawer: (newState) => set((state) => ({ ...state, ...newState, isOpen: true })),
  onResetConfirmDrawer: () => set(() => initialState),
}));
